var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsPtz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0u98qfrc3a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5C9.792 5 8 6.792 8 9s1.792 4 4 4 4-1.792 4-4-1.792-4-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 17a2.5 2.5 0 0 0 0 5h11a2.5 2.5 0 0 0 0-5h-11zm9.5 2.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 16 19.5zM5 9c0-3.864 3.136-7 7-7s7 3.136 7 7a7.004 7.004 0 0 1-2.184 5.08c.512.56.917 1.209 1.184 1.92H6c.267-.711.672-1.36 1.184-1.92A7.004 7.004 0 0 1 5 9zm1.4 0c0 3.087 2.513 5.6 5.6 5.6 3.087 0 5.6-2.513 5.6-5.6 0-3.087-2.513-5.6-5.6-5.6A5.607 5.607 0 0 0 6.4 9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0u98qfrc3a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPtz);
export default __webpack_public_path__ + "static/media/Icons_PTZ.fdadaaffc14745e67d3cc5bb01f32730.svg";
export { ForwardRef as ReactComponent };